export default __webpack_public_path__ + "static/media/StarterKit_Main.4472f51b.png";